<div class="row">
  <div class="col">
    <mat-card>
      <mat-card-content>
        <div class="row" style="margin: 0" *ngFor="let group of filteredArr">
          <div *ngFor="let item of group.items">
            <div *ngFor="let child of item.childs">
              <div *ngFor="let schild of child.schilds">
                <div *ngIf="schild.tchilds && schild.tchilds.length > 0">
                  <p class="subHeader">{{ schild.name }}</p>
                  <ul>
                    <li class="row" style="margin: 0; margin-bottom: 10px" *ngFor="let tchild of schild.tchilds">
                      <a mat-button class="align-left" [ngClass]="{'active-button': isSubChildActive(tchild.route)}" [routerLink]="['/TCO/ProcessEng/' + tchild.route]">
                        {{ tchild.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>